import * as React from 'react'
import {connect} from 'react-redux'
import Helmet from 'react-helmet'
// import Checkbox from '../../components/Checkbox'
// import AssociationLine from '../../components/AssociationLine'
// import { WS_HOST } from '../../config'
// import history from '../../history'
// import PageComponent from '../../components/Pagination'
import {getFavoriteListSuccess} from '../../components/Header/actions'
// import ArticleBox from '../../components/ArticleBox'
// import AnalystDetails from '../../components/AnalystDetails'
// import SearchFilter from '../../components/SearchFilter'
import SearchPerson from '../../components/SearchPerson'
import {
    getAuthor,
} from './actions'

import {
    submitQuerySuccess,
    fetchQuery,
    fetchQueryRealTime,
} from '../../components/SearchInput/actions'

import {
    // fetchSubscribes,
    fetchedSubscribes
} from '../Article/actions'

import './index.css'
import '../../css/public.css'
import {updateFavoriteArticle} from '../../actions'
import {sortReports, objToArray} from '../../util'

class Search extends React.Component<any, any> {
    private intervalQuery: any

    constructor(props: any) {
        super(props)
        this.state = {
            sortType: [
                {checked: true, name: '文章评分', eName: '_score'},
                {checked: false, name: '按作者评分', eName: '_score'},
                {checked: false, name: '按机构评分', eName: '_score'},
                {checked: false, name: '按时间排序', eName: 'created_at'}
            ],
            barChartData: [{name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
                {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
                {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
                {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
                {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
                {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
                {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
            ],
            current: 20, //  当前页码
            pageSize: 5, //  每页显示的条数5条
            barChartVisible: false,
            score: {}, //  评分假数据
            topScore: [],
            topCompany: [],
            filterQueryPerson: [],
            loadMore: false
        }
    }

    componentDidMount() {
        this.setState(
            {
                score: this.getScore(),
                topScore: this.getTopScore(),
                topCompany: this.getTopCompany(),
            }
        )
        this.props.fetchQuery({text: this.props.match.params.input, limit: this.state.current})
        let queryInterval = () => {
            this.props.fetchQueryRealTime({text: this.props.match.params.input})
        }
        this.intervalQuery = setInterval(queryInterval, 3000)
    }

    clearQuery = () => {
        clearInterval(this.intervalQuery)
        this.setState({
            loadMore: true
        })
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props.queryPerson.completed_results && objToArray(this.props.queryPerson.completed_results).length === 0) {
            this.props.fetchQueryRealTime(null)
        }
        this.updateQueryPerson()
    }

    //  离开页面函数
    componentWillUnmount() {
        this.props.getAuthor('')

    }

    goTo(url: string) {
        window.open(url, '_blank')
    }

    updateFavoriteState(action: string, index: number) {
        const data = {
            action: action,
            favorites_list: this.props.queryPerson.entities [index]._id
        }
        this.props.updateFavoriteArticle(data)

        let newReports = this.props.queryPerson.entities
        newReports [index].enable_favorites = !this.props.queryPerson.entities [index].enable_favorites
        this.props.fetchQueryReports(newReports)

        if (this.props.favoriteList.entities) {
            let favorites = this.props.favoriteList.entities
            if (action === 'add') {
                favorites.push(
                    {
                        id: this.props.queryPerson.entities [index]._id,
                        title: this.props.queryPerson.entities [index].highlight.article_title
                    }
                )
            } else {
                for (let i = 0; i < favorites.length; i++) {
                    if (favorites[i].id === this.props.queryPerson.entities [index]._id) {
                        favorites.splice(i, 1)
                    }
                }
            }
            this.props.fetchFavoriteList(favorites)
        }
    }

    handlePageChange() {
        this.props.fetchQuery({text: this.props.match.params.input, limit: this.state.current})
    }

    updateSort(index: number) {
        let newSort = this.state.sortType
        for (let i = 0; i < newSort.length; i++) {
            newSort[i].checked = false
        }
        newSort[index].checked = true
        this.setState(
            {
                sortType: newSort
            }
        )
        let queryPerson = {
            ...this.props.queryPerson.entities,
            hit: {
                ...this.props.queryPerson.entities.hits,
                hits: sortReports(this.state.sortType[index].eName, this.props.queryPerson.entities)
            }
        }
        this.props.fetchQueryReports(queryPerson)

    }

    //  点击翻页
    pageClick(page: any) {
        this.setState(
            {
                current: page
            }
        )
        if (page !== this.state.current) {
            this.props.fetchQuery({text: this.props.match.params.input, limit: page})
        }
    }

    //  上一步
    goPrevClick() {
        let cur = this.state.current;
        if (cur > 1) {
            this.pageClick(cur - 1);
        }
    }

    //  下一步
    goNext() {
        let cur = this.state.current;
        //  alert(cur+"==="+this.state.totalPage)
        if (cur < Math.ceil(this.props.queryPerson.entities.hits.total / 10)) {
            this.pageClick(cur + 1);
        }
    }

    //  跳转到指定页
    goSwitchChange(page: any) {
        //  alert(value+"==="+this.state.totalPage)
        let totalPage = Math.ceil(this.props.queryPerson.entities.hits.total / 10)
        if (/^[1-9]\d*$/.test(page) && Number(page) <= Number(totalPage)) {
            this.pageClick(page);
        }
    }

    getNewAuthor(author: any) {
        if (!author) {
            return
        }
        for (let i = 0; i < author.length; i++) {
            if (author[i].expire_date) {
                return author[i]
            }
        }
    }

    closeBarChart() {
        this.setState(
            {
                barChartVisible: false
            }
        )
    }

    changeBarChart() {
        this.setState(
            {
                barChartVisible: true
            }
        )
    }

    handleCheckboxChange = (type: number, checked: boolean, index: number) => {
        let newEntities = this.props.subscribes.entities
        newEntities[type].value[index].checked = !checked
        // immediately toggle checkbox
        this.props.fetchedSubscribes(newEntities)

        // this.updateMySubscribes(newEntities, 1)
        //
        // this.props.submitSubscribes({
        //     list_subscribe: this.mySubscribes.join(',')
        // })
    }

    showCheckbox(index: any) {
        let newEntities = this.props.subscribes.entities
        newEntities[index].checked = !this.props.subscribes.entities[index].checked
        this.props.fetchedSubscribes(newEntities)
        // this.updateMySubscribes(newEntities, 1)
    }

    getScore() {
        const research: any = (Math.random() * 50 + 50).toFixed(0)
        const forecast: any = (Math.random() * 50 + 50).toFixed(0)
        let comprehensive: any = ((parseInt(research, 10) * 2 + parseInt(forecast, 10)) / 3).toFixed(0)
        return {
            research: research, forecast: forecast, comprehensive: comprehensive
        }
    }

    getTopScore() {
        let score = []
        let temp = []
        let industry = ['环保行业', '非金属类建材行业', '食品饮料行业', '医药行业', '机械行业', '轻工制造', '纺织和服装行业', '通信行业', '轨交行业', '公用事业行业', '电子行业', '钢铁行业', '电力行业', '交通运输行业', '汽车及零部件行业', '有色金属行业', '教育行业', '房地产行业', '证券信托行业', '银行行业', '家电行业', '零售业行业']
        for (let i = 0; i < 5; i++) {
            temp[i] = (Math.random() * 50 + 50).toFixed(0)
        }
        temp.sort(this.sortNumber)
        for (let i = 0; i < 5; i++) {
            score[i] = {}
            score[i] = {value: temp[i], name: industry[i]}
        }
        return score
    }

    getTopCompany() {
        let score = []
        let temp = []
        let industry = ['汇纳科技', '博世科', '鱼跃医疗', '通威股份', '中电环保', '百川能源', '跨境通', '立讯精密', '平安银行', '大业股份', '京新药业', '苏博特', '高新兴', '日海通讯', '富春环保', '华宏科技', '裕同科技', '四方冷链', '中泰化学', '蓝焰控股', '兴发集团', '山西证券', '华兰生物', '金科文化', '江中药业', '鱼跃医疗', '通化东宝', '京新药业', '中工国际', '新野纺织', '八一钢铁', '龙元建设', '雄韬股份']
        for (let i = 0; i < 5; i++) {
            temp[i] = (Math.random() * 50 + 50).toFixed(0)
        }
        temp.sort(this.sortNumber)
        for (let i = 0; i < 5; i++) {
            score[i] = {}
            score[i] = {value: temp[i], name: industry[i]}
        }
        return score
    }

    sortNumber(a: any, b: any) {
        return b - a
    }

    goToAuthor(authorId: any) {
        return 1
    }

    updateQueryPerson() {
        if (this.props.queryPerson.entities && this.props.queryPerson.entities.mode) {
            this.clearQuery()
        }
        if (this.props.queryPersonRealTime.entities) {
            this.setState(
                {
                    filterQueryPerson: this.props.queryPersonRealTime.entities
                }
            )
            if (this.props.queryPersonRealTime.entities.job_status.global_job_count === 0) {
                this.clearQuery()
            }
        } else {
            if (this.props.queryPerson.entities) {
                this.setState(
                    {
                        filterQueryPerson: this.props.queryPerson.entities
                    }
                )
            }
        }
    }

    render() {
        const queryPerson = this.state.filterQueryPerson
        const quickQuery = this.props.queryPerson.entities
        const loadMore = this.state.loadMore
        return (
            <div className="author grow">
                <Helmet title="搜索"/>
                <div className="article-container">
                    {/*<div className="search-state">*/}
                    {/*{*/}
                    {/*objToArray(queryPerson).length === 0 ?*/}
                    {/*<div className="loading-box">*/}
                    {/*<img src={require('./img/loading.gif')} alt=""/>*/}
                    {/*</div>*/}
                    {/*: ''*/}
                    {/*}*/}
                    {/*</div>*/}
                    {
                        (quickQuery || queryPerson) &&
                        <div className="articleList">
                            <div className="search-container">
                                <div className="search-type">
                                    <div>
                                        快速结果
                                    </div>
                                    <div>
                                        {!quickQuery ?
                                            '正在解析搜索结果.....' : ((objToArray(quickQuery.completed_results).length > 0 || quickQuery.mode) ? '解析完毕' : '没有搜到相关联系方式')}
                                    </div>
                                </div>
                                {
                                    objToArray(quickQuery).length > 0 &&
                                    <SearchPerson queryPerson={quickQuery.preview_results}
                                                  name={this.props.match.params.input}/>
                                }
                                {
                                    !quickQuery &&
                                    <div>
                                        <img src={require('./img/loading.gif')} alt=""/>
                                    </div>
                                }
                            </div>

                            <div className="search-container">
                                <div className="search-type">
                                    <div>
                                        深度解析
                                    </div>
                                    <div>
                                        {!loadMore && queryPerson ?
                                            '正在解析搜索结果.....' : (objToArray(queryPerson.completed_results).length > 0 ? '解析完毕' : '没有搜到相关联系方式')}
                                    </div>
                                </div>
                                {
                                    objToArray(queryPerson).length > 0 &&
                                    <SearchPerson queryPerson={queryPerson.completed_results}
                                                  name={this.props.match.params.input}/>
                                }
                                {
                                    !loadMore &&
                                    <div>
                                        <img src={require('./img/loading.gif')} alt=""/>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        token: state.fetchedToken,
        subscribes: state.getSubscribes,
        Author: state.author,
        favoriteList: state.favoriteList,
        queryPerson: state.queryPerson,
        queryPersonRealTime: state.queryPersonRealTime,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        // fetchSubscribes: (data: object) => dispatch(fetchSubscribes(data)),
        fetchedSubscribes: (data: any) => dispatch(fetchedSubscribes(data)),
        getAuthor: (data: object) => dispatch(getAuthor(data)),
        fetchQueryReports: (data: object) => dispatch(submitQuerySuccess(data)),
        updateFavoriteArticle: (data: object) => dispatch(updateFavoriteArticle(data)),
        fetchFavoriteList: (data: object) => dispatch(getFavoriteListSuccess(data)),
        fetchQuery: (data: object) => dispatch(fetchQuery(data)),
        fetchQueryRealTime: (data: object) => dispatch(fetchQueryRealTime(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Search/index.tsx